import { ModelDataType } from 'src/app/interfaces/model-data-type';
import { Invoice } from 'src/app/interfaces/models/invoice';
import { TransactionStatus } from 'src/app/interfaces/transaction-status';

import { BaseModel } from './base-model';
import { PaymentProvider } from './payment-provider';

export class Transaction extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static TransactionProperties: (
    | {
        property: keyof Transaction;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof Transaction;
        type: 'alias';
      }
    | {
        property: keyof Transaction;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'PaymentProviderId', type: 'column', dataType: 'number' },
    { property: 'InvoiceId', type: 'column', dataType: 'number' },
    { property: 'transType', type: 'column', dataType: 'string' },
    { property: 'transMethod', type: 'column', dataType: 'string' },
    { property: 'amount', type: 'column', dataType: 'number' },
    { property: 'status', type: 'column', dataType: 'string' },
    { property: 'refNumber', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'Invoice', model: 'Invoice', type: 'association' },
    {
      property: 'PaymentProvider',
      model: 'PaymentProvider',
      type: 'association'
    }
  ];

  static {
    Transaction.TransactionProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        Transaction.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        Transaction.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        Transaction.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(TransactionObject: Partial<Transaction>) {
    super();

    Transaction.TransactionProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = TransactionObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  PaymentProviderId?: number | null;
  InvoiceId?: number;
  transType?: 'CREDIT' | 'DEBIT';
  transMethod?: 'ONLINE' | 'CASH' | 'CHECK';
  amount?: number;
  status?: TransactionStatus;
  refNumber?: string;
  createdAt?: Date;
  updatedAt?: Date;

  Invoice?: Invoice;
  PaymentProvider?: PaymentProvider;
}
